import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircularLoader = (props) => /* @__PURE__ */ _jsxs("svg", {
	"cache-id": "7e8ebd2ef26d4c7b965812759465fe3d",
	id: "ex0TY5t2Kgl1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 70 70",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		transform: "translate(0-3)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "ex0TY5t2Kgl3_to",
			transform: "translate(43.5,61)",
			children: /* @__PURE__ */ _jsx("ellipse", {
				rx: 26.5,
				ry: 11,
				transform: "translate(0,0)",
				fill: "url(#ex0TY5t2Kgl3-fill)"
			})
		}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
			id: "ex0TY5t2Kgl5_to",
			transform: "translate(211.398499,36)",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(-211.398499,-36)",
				mask: "url(#ex0TY5t2Kgl32)",
				children: [/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("circle", {
							r: 22,
							transform: "translate(35 36)",
							fill: "url(#ex0TY5t2Kgl8-fill)"
						}),
						/* @__PURE__ */ _jsx("circle", {
							r: 22,
							transform: "translate(35 36)",
							fill: "url(#ex0TY5t2Kgl9-fill)"
						}),
						/* @__PURE__ */ _jsx("circle", {
							r: 22,
							transform: "translate(35 36)",
							fill: "url(#ex0TY5t2Kgl10-fill)"
						}),
						/* @__PURE__ */ _jsx("circle", {
							r: 22,
							transform: "translate(35 36)",
							fill: "#0a0a0a",
							fillOpacity: .1
						})
					] }),
					/* @__PURE__ */ _jsx("ellipse", {
						rx: 15,
						ry: 11,
						transform: "translate(30 25)",
						fill: "url(#ex0TY5t2Kgl12-fill)"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", {
						id: "ex0TY5t2Kgl14_to",
						transform: "translate(177.52375,43.999697)",
						children: /* @__PURE__ */ _jsxs("g", {
							transform: "translate(-211.398499,-43.999997)",
							children: [
								/* @__PURE__ */ _jsx("g", {
									opacity: .9,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M92.3594,37.9655h-1.4549c-1.455,0-4.4309,0-7.3408.5566-2.976.5564-5.8859,1.6695-8.8618,2.7824-2.9098,1.1131-5.8857,2.2261-8.7957,1.6697-2.9098-.5566-5.8857-2.7826-8.7957-6.1218-2.9759-3.339-5.8857-7.7911-8.8618-6.6781-2.9098,1.1131-5.8857,7.7912-8.7955,12.2433-2.91,4.4521-5.8859,6.6782-8.7957,6.1216-2.9761-.5565-5.8859-3.8955-8.8618-6.6781-2.91-2.7826-3.6561-2.7819-4.9502-3.8544-.4335-.3594-2.8205-1.6081-3.8455-1.6081L13,58h79.3591v-20.0345h.0003Z",
										opacity: .9,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl16-fill)",
										fillRule: "evenodd"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									opacity: .9,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M92.3596,37.9655h1.4549c1.4549,0,4.4309,0,7.3405.5566c2.976.5564,5.886,1.6695,8.862,2.7824c2.91,1.1131,5.886,2.2261,8.796,1.6697c2.91-.5566,5.885-2.7826,8.795-6.1218c2.976-3.339,5.886-7.7911,8.862-6.6781c2.91,1.1131,5.886,7.7912,8.796,12.2433s5.886,6.6782,8.795,6.1216c2.977-.5565,5.886-3.8955,8.862-6.6781c2.91-2.7826,4.155-4.1645,5.727-4.8538c1.207-.5292,2.295-.5268,3.069-.6087v21.6014h-79.3596v-20.0345h.0002Z",
										opacity: .9,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl18-fill)",
										fillRule: "evenodd"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									opacity: .9,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M251.078,37.9655h-1.455c-1.455,0-4.431,0-7.341.5566-2.976.5564-5.885,1.6695-8.861,2.7824-2.91,1.1131-5.886,2.2261-8.796,1.6697-2.91-.5566-5.886-2.7826-8.796-6.1218-2.976-3.339-5.885-7.7911-8.862-6.6781-2.909,1.1131-5.885,7.7912-8.795,12.2433s-5.886,6.6782-8.796,6.1216c-2.976-.5565-5.886-3.8955-8.862-6.6781-2.91-2.7826-3.656-2.7819-4.95-3.8544-.433-.3594-2.82-1.6081-3.845-1.6081v21.6014h79.359v-20.0345v0Z",
										opacity: .9,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl20-fill)",
										fillRule: "evenodd"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									opacity: .9,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M251.078,37.9655h1.455c1.455,0,4.431,0,7.341.5566c2.976.5564,5.886,1.6695,8.862,2.7824c2.909,1.1131,5.885,2.2261,8.795,1.6697c2.91-.5566,5.886-2.7826,8.796-6.1218c2.976-3.339,5.886-7.7911,8.862-6.6781c2.91,1.1131,5.886,7.7912,8.795,12.2433c2.91,4.4521,5.886,6.6782,8.796,6.1216c2.976-.5565,5.886-3.8955,8.862-6.6781c2.91-2.7826,3.656-2.7819,4.95-3.8544.434-.3594,2.821-1.6081,3.846-1.6081v21.6014h-79.36v-20.0345v0Z",
										opacity: .9,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl22-fill)",
										fillRule: "evenodd"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									opacity: .9,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M409.797,37.9655h-1.455c-1.455,0-4.431,0-7.341.5566-2.976.5564-5.886,1.6695-8.862,2.7824-2.909,1.1131-5.885,2.2261-8.795,1.6697-2.91-.5566-5.886-2.7826-8.796-6.1218-2.976-3.339-5.886-7.7911-8.862-6.6781-2.91,1.1131-5.886,7.7912-8.795,12.2433-2.91,4.4521-5.886,6.6782-8.796,6.1216-2.976-.5565-5.886-3.8955-8.862-6.6781-2.91-2.7826-3.656-2.7819-4.95-3.8544-.434-.3594-2.821-1.6081-3.845-1.6081v21.6014h79.359v-20.0345v0Z",
										opacity: .9,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl24-fill)",
										fillRule: "evenodd"
									})
								})
							]
						})
					}), /* @__PURE__ */ _jsx("g", {
						id: "ex0TY5t2Kgl25_to",
						transform: "translate(132.039001,44.666399)",
						children: /* @__PURE__ */ _jsxs("g", {
							transform: "translate(-132.039001,-44.666399)",
							children: [
								/* @__PURE__ */ _jsx("g", {
									opacity: .3,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M92.3596,47.9998h1.4549c1.4549,0,4.4309,0,7.3405-1.6668c2.976-1.6666,5.886-5,8.862-7.2221c2.91-2.2222,5.886-3.3334,8.796-4.4444c2.91-1.1112,5.885-2.2222,8.795.5556c2.976,2.7777,5.886,9.4443,8.862,9.9999c2.91.5556,5.886-5,8.796-5s5.886,5.5556,8.795,5c2.977-.5556,5.886-7.2221,8.862-10.5555c2.91-3.3334,5.886-3.3334,7.341-3.3334h1.455v26.6666h-79.3596v-9.9999h.0002Z",
										opacity: .3,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl27-fill)",
										fillRule: "evenodd"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									opacity: .3,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M251.078,47.9998h-1.455c-1.455,0-4.431,0-7.341-1.6668-2.976-1.6666-5.885-5-8.861-7.2221-2.91-2.2222-5.886-3.3334-8.796-4.4444-2.91-1.1112-5.886-2.2222-8.796.5556-2.976,2.7777-5.885,9.4443-8.862,9.9999-2.909.5556-5.885-5-8.795-5s-5.886,5.5556-8.796,5c-2.976-.5556-5.886-7.2221-8.862-10.5555-2.91-3.3334-5.885-3.3334-7.34-3.3334h-1.455v26.6666h79.359v-9.9999v0Z",
										opacity: .3,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl29-fill)",
										fillRule: "evenodd"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									opacity: .3,
									children: /* @__PURE__ */ _jsx("path", {
										d: "M92.3594,47.9998h-1.455c-1.4548,0-4.4309,0-7.3407-1.6668-2.9759-1.6666-5.8859-5-8.8618-7.2221-2.9098-2.2222-5.8857-3.3334-8.7957-4.4444-2.9098-1.1112-5.8857-2.2222-8.7957.5556-2.9759,2.7777-5.8857,9.4443-8.8618,9.9999-2.9098.5556-5.8857-5-8.7955-5-2.91,0-5.8859,5.5556-8.7957,5-2.9761-.5556-5.8859-7.2221-8.8618-10.5555-2.91-3.3334-5.8859-3.3334-7.3409-3.3334h-1.4548v26.6666h79.3596v-9.9999h-.0002Z",
										opacity: .3,
										clipRule: "evenodd",
										fill: "url(#ex0TY5t2Kgl31-fill)",
										fillRule: "evenodd"
									})
								})
							]
						})
					})] })
				] }), /* @__PURE__ */ _jsx("mask", {
					id: "ex0TY5t2Kgl32",
					"mask-type": "alpha",
					x: "-150%",
					y: "-150%",
					height: "400%",
					width: "400%",
					children: /* @__PURE__ */ _jsx("circle", {
						r: 22,
						transform: "translate(35 36)",
						fill: "#c4c4c4"
					})
				})]
			})
		}) })]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "ex0TY5t2Kgl3-fill",
			cx: 0,
			cy: 0,
			r: 1,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(19.1389 7.33331 -4.916 12.83 -1.4722 -0.6111)",
			children: [/* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl3-fill-0",
				offset: "18.75%",
				stopColor: "rgba(0,0,0,0.22)"
			}), /* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl3-fill-1",
				offset: "100%",
				stopColor: "rgba(0,0,0,0)"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl8-fill",
			x1: 0,
			y1: -22,
			x2: 0,
			y2: 22,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [/* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl8-fill-0",
				offset: "0%",
				stopColor: "#27829c"
			}), /* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl8-fill-1",
				offset: "100%",
				stopColor: "#0a454d"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "ex0TY5t2Kgl9-fill",
			cx: 0,
			cy: 0,
			r: 1,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(30.1215 -9.38665 7.31732 23.4811 -22 20.6311)",
			children: [/* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl9-fill-0",
				offset: "0%",
				stopColor: "#1b4963"
			}), /* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl9-fill-1",
				offset: "100%",
				stopColor: "rgba(27,73,99,0.02)"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "ex0TY5t2Kgl10-fill",
			cx: 0,
			cy: 0,
			r: 1,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(-44 -2.76207 3.646959 -58.0963 22 20.1422)",
			children: [/* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl10-fill-0",
				offset: "0%",
				stopColor: "#705257"
			}), /* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl10-fill-1",
				offset: "100%",
				stopColor: "rgba(112,82,87,0.02)"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "ex0TY5t2Kgl12-fill",
			cx: 0,
			cy: 0,
			r: 1,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(10.8333 7.33333 -6.83023 10.0901 -0.8333 -0.6111)",
			children: [/* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl12-fill-0",
				offset: "18.75%",
				stopColor: "rgba(255,255,255,0.18)"
			}), /* @__PURE__ */ _jsx("stop", {
				id: "ex0TY5t2Kgl12-fill-1",
				offset: "100%",
				stopColor: "rgba(255,255,255,0)"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl16-fill",
			x1: 51.9693,
			y1: 14.2957,
			x2: 51.9693,
			y2: 58,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl16-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl16-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl16-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl18-fill",
			x1: 132.75,
			y1: 14.2956,
			x2: 132.75,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl18-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl18-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl18-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl20-fill",
			x1: 210.688,
			y1: 14.2956,
			x2: 210.688,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl20-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl20-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl20-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl22-fill",
			x1: 291.468,
			y1: 14.2956,
			x2: 291.468,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl22-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl22-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl22-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl24-fill",
			x1: 369.407,
			y1: 14.2956,
			x2: 369.407,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl24-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl24-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl24-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl27-fill",
			x1: 132.75,
			y1: 16.3768,
			x2: 132.75,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl27-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl27-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl27-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0.8)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl29-fill",
			x1: 210.688,
			y1: 16.3768,
			x2: 210.688,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl29-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl29-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl29-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0.8)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "ex0TY5t2Kgl31-fill",
			x1: 51.9693,
			y1: 16.3768,
			x2: 51.9693,
			y2: 57.9999,
			spreadMethod: "pad",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl31-fill-0",
					offset: "0%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl31-fill-1",
					offset: "6%",
					stopColor: "#f5f5f5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					id: "ex0TY5t2Kgl31-fill-2",
					offset: "100%",
					stopColor: "rgba(255,255,255,0.8)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("style", { children: "\r\n#ex0TY5t2Kgl3_to {animation: ex0TY5t2Kgl3_to__to 6000ms linear infinite normal forwards}@keyframes ex0TY5t2Kgl3_to__to { 0% {transform: translate(43.5px,61px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 25% {transform: translate(43.5px,59.9997px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 50% {transform: translate(43.5px,61px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 75% {transform: translate(43.5px,59.9997px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {transform: translate(43.5px,61px)}} #ex0TY5t2Kgl5_to {animation: ex0TY5t2Kgl5_to__to 6000ms linear infinite normal forwards}@keyframes ex0TY5t2Kgl5_to__to { 0% {transform: translate(211.398499px,36px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 25% {transform: translate(211.398499px,39px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 50% {transform: translate(211.398499px,36px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 75% {transform: translate(211.398499px,39px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {transform: translate(211.398499px,36px)}} #ex0TY5t2Kgl14_to {animation: ex0TY5t2Kgl14_to__to 6000ms linear infinite normal forwards}@keyframes ex0TY5t2Kgl14_to__to { 0% {transform: translate(177.52375px,43.999697px)} 100% {transform: translate(-139.398498px,43.999701px)}} #ex0TY5t2Kgl25_to {animation: ex0TY5t2Kgl25_to__to 6000ms linear infinite normal forwards}@keyframes ex0TY5t2Kgl25_to__to { 0% {transform: translate(132.039001px,44.666399px)} 100% {transform: translate(-26.229899px,44.6664px)}}\r\n" })
	] })]
});
export default SvgCircularLoader;
